export default function NavBarTab({ text, icon, onClick, isActive }) {
  return (
    <li
      onClick={onClick}
      className={`nav-links p-3 rounded-3 cpoint d-inline-block ${isActive ? "active" : ""}`}
    >
      <button className="d-flex align-items-center gap-2">
        <i className={`ti ${icon} fs-five n5-color`}></i>
        <span className="text-nowrap">{text}</span>
      </button>
    </li>
  );
}
